import React from 'react';

import {translate} from 'iss/strings';
import {removeQuestionGroupFromQuestion} from 'iss/service/QuestionService';
import {runBatchOps} from 'iss/utils/batchOps';
import {CollapsibleButtonPanel} from 'iss/widgets/Panels';
import {QuestionList} from 'iss/widgets/QuestionList';
import {QuestionGroupSelector} from 'iss/widgets/Selectors';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listFailuresWithMessage} from 'iss/widgets/batchOps/question/BatchOpFailure';
import validators from 'iss/widgets/form/validation/validators';

const removeQuestionGroup = {
    id: "removeGroup",
    title: "questionOperations.removeGroup.title",
    progressMessage: "questionOperations.removeGroup.progressMessage",
    components: {
      settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('questionOperations.removeGroup.proceed')}
        onSubmit={(formData) => startOperation(removeQuestionGroups(operationTargets, formData))}
        onCancel={onCancel}>
        <QuestionGroupSelector id="groups" valuePath="groupId" label="questionOperations.removeGroup.chooseQuestionGroup" clearable={false} validate={validators.required} />
        <p>
          {translate('questionOperations.removeGroup.confirmMessage', {count: operationTargets.length})}
        </p>
        <CollapsibleButtonPanel buttonText={translate('questionOperations.removeGroup.questions')}>
          <QuestionList compact={true} questions={operationTargets} />
        </CollapsibleButtonPanel>
      </ModalForm>,
      success: <p>{translate("questionOperations.removeGroup.success")}</p>,
      failure: listFailuresWithMessage("questionOperations.removeGroup.failure")
    },
};

function removeQuestionGroups(targets, {groupId}) {
  const ops = targets.map((target) => (
    {operation: removeQuestionGroupFromQuestion(target.id, groupId),
    question: target
    }));
  return runBatchOps(ops);
}

export default removeQuestionGroup;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/question/removeQuestionGroup.jsx